import apiTrainings from '@/api/trainings'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getTrainingsStart: '[trainings] Get training start',
  getTrainingsSuccess: '[training] Get trainings success',
  getTrainingsFailure: '[training s] Get trainings failure',

  getTrainingsSchoolIdStart: '[trainings] Get trainings schoolId start',
  getTrainingsSchoolIdSuccess: '[trainings] Get trainings schoolId success',
  getTrainingsSchoolIdFailure: '[trainings] Get trainings schoolId failure'
}

export const actionTypes = {
  getTrainings: '[trainings] Get training',
  getTrainingsSchoolId: '[trainings] Get trainings schoolId'
}

const mutations = {
  [mutationTypes.getTrainingsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingsFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainingsSchoolIdStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainingsSchoolIdSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainingsSchoolIdFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getTrainings](context) {
    context.commit(mutationTypes.getTrainingsStart)
    return new Promise(resolve => {
      apiTrainings
        .getTrainings()
        .then(response => {
          context.commit(mutationTypes.getTrainingsSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingsFailure)
        })
    })
  },

  [actionTypes.getTrainingsSchoolId](context, {schoolId, schoolType}) {
    const params = {
      schoolId,
      schoolType
    }
    context.commit(mutationTypes.getTrainingsSchoolIdStart)
    return new Promise(resolve => {
      apiTrainings
        .getTrainingsBySchoolId(params)
        .then(response => {
          context.commit(
            mutationTypes.getTrainingsSchoolIdSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainingsSchoolIdFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
